import styled from 'styled-components'

// The page surface + footer live in the shared @components/PublicPage shell;
// this file only styles what is specific to the per-section frame.


export const TopBar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 24px;
`

/** Tightens the shared Breadcrumbs' own vertical padding inside the TopBar. */
export const CrumbRow = styled.div`
	nav {
		padding: 0;
	}
`
